import React from 'react';
// import { templateArray } from '../Constants';
// import Template1 from './Template1';
// import Template2 from './Template2';
// import Template3 from './Template3';
// import Template4 from './Template4';
// import Template5 from './Template5';

import Cards from './Cards/Cards';
import { T } from '../Utils';
import Button from '../../Buttons/Button/Button';
import { returnSaneURL } from '../../../../Utils/getImg';
import { TString } from '../Utils';
// const templateMapping = {
//   1: Template1,
//   2: Template2,
//   3: Template3,
//   4: Template4,
//   5: Template5
// };
// template mappoing might be required in future
interface Props {
	data: any;
	singleCard?: any;
	handleSubmit?: Function;
	shouldDisableActions?: boolean;
	isMultiChoice?: boolean;
	isMultiSelect?: boolean;
	botImageCheck: boolean;
	index: number;
	logoImagePath?: string;
	voiceResponse: boolean;
	lengthArray: number;
	langCode: string;
	addUserResponse: Function;
	channel?: string;
	timeStamp?: string;
	getProductDetails?: Function;
}
const List = (props: Props) => {
	let {
		data,
		singleCard,
		handleSubmit,
		shouldDisableActions,
		isMultiChoice,
		isMultiSelect,
		botImageCheck,
		index,
		logoImagePath,
		voiceResponse,
		lengthArray,
		langCode,
		addUserResponse,
		channel,
		getProductDetails,
		timeStamp,
	} = props;
	const [selectionArray, setSelectionArray] = React.useState([]);

	React.useEffect(() => {
		if (
			selectionArray.length === 0 &&
			data.lists &&
			data.lists.items.length > 0
		) {
			setSelectionArray(data.lists.items.map((e) => e.selectedFlag === '1'));
		}
	}, [selectionArray]);
	const toggleInput = (list) => {
		document.getElementById('sfChatInputMain').style.visibility =
			data.lists.items.filter((_, index) => list[index]).length !== 0
				? 'hidden'
				: 'visible';
	};
	const handleSelection = (index) => {
		let __selectionArray = [...selectionArray];
		__selectionArray[index] = !__selectionArray[index];
		setSelectionArray(__selectionArray);
		toggleInput(__selectionArray);
	};

	const cancelSelections = () => {
		setSelectionArray(data.lists.items.map((e) => false));
		toggleInput([]);
	};
	const handleConfirm = () => {
		const selectedElements = data.lists.items.filter(
			(_, index) => selectionArray[index]
		);
		if (selectedElements.length === 0) return;
		const itemsToSend = selectedElements
			.map((e) => e.actionText || e.title)
			.join(', ');
		toggleInput([]);
		handleSubmit(itemsToSend);
	};
	if (singleCard) data = { lists: { items: [data.card] } };

	let cardLayout =
		data.lists && data.lists.items.length > 0
			? data.lists.items[0].cardLayout || 0
			: 0;

	// const templateType = templateArray[cardLayout].type;
	// const order = templateArray[cardLayout].order;
	// const Template = templateMapping[templateType];
	return (
		<div
			style={
				props.channel === 'whatsapp' ? { display: 'grid', gap: '4px' } : {}
			}
		>
			{botImageCheck && index == 0 ? (
				<div className={'preview-image-holder'}>
					<img
						src={returnSaneURL(logoImagePath)}
						alt={TString({ labelName: 'botAvatarLabel' })}
					/>
				</div>
			) : null}
			{data.displayResponse ? (
				channel === 'whatsapp' ? (
					<div
						className='sf-whatsapp-title-time'
						tabIndex={voiceResponse || props.shouldDisableActions ? -1 : 0}
					>
						<div
							className='sf-whatsapp-title body-text-1'
							dangerouslySetInnerHTML={{
								__html: data.displayResponse,
							}}
						/>
						<p className='whatsApp-time'>{props.timeStamp}</p>{' '}
					</div>
				) : (
					<div
						tabIndex={voiceResponse || shouldDisableActions ? -1 : 0}
						className={`list-carousel-message `}
						// ${
						//   props.index == lengthArray && props.index == 0
						//     ? ''
						//     : props.index == 0
						//     ? 'first-curve'
						//     : props.index == lengthArray
						//     ? 'last-curve'
						//     : 'no-curve'
						// }
						dangerouslySetInnerHTML={{
							__html: data.displayResponse,
						}}
					/>
				)
			) : null}

			{data.lists && data.lists.items.length > 0 ? (
				<>
					<div
						tabIndex={voiceResponse || shouldDisableActions ? -1 : 0}
						className={`list-carousel-wrapper `}
					>
						{data.lists.items.length > 0 &&
							data.lists.items.map((eachCard, index) => (
								<Cards
									key={eachCard.title}
									{...eachCard}
									onClick={() => {
										if (isMultiChoice) {
											if (eachCard.productId) {
												getProductDetails(eachCard.productId, eachCard.title);
												// handleSubmit(
												// 	eachCard.productId.toString(),
												// 	{},
												// 	{ isHidden: true }
												// );
											} else {
												handleSubmit(eachCard.actionText || eachCard.title);
											}
										} else if (isMultiSelect) {
											handleSelection(index);
										}
									}}
									selected={selectionArray[index]}
									isMultiChoice={isMultiChoice}
									isMultiSelect={isMultiSelect}
									disabled={shouldDisableActions}
									typeGrid
									miniCards={['0', '5', '9'].includes(cardLayout)}
									onlyImage={cardLayout === '8'}
									voiceResponse={voiceResponse}
									langCode={langCode}
									channel={channel}
									timeStamp={timeStamp}
									handleSubmit={handleSubmit}
									listsCount={data.lists.items.length}
								/>
							))}
					</div>
					{isMultiSelect &&
					!shouldDisableActions &&
					data.lists.items.filter((_, index) => selectionArray[index])
						.length !== 0 ? (
						<div className='list-carousel-submit'>
							<Button
								label={<T labelName='submitLabel' />}
								onClick={handleConfirm}
							/>
							<Button
								label={<T labelName='cancelLabel' />}
								onClick={() => {
									cancelSelections();
								}}
							/>
						</div>
					) : null}
				</>
			) : null}
		</div>
	);
};

export default List;
